import { render, staticRenderFns } from "./UplaodSection.vue?vue&type=template&id=1aa8b8cc&scoped=true"
import script from "./UplaodSection.vue?vue&type=script&lang=js"
export * from "./UplaodSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa8b8cc",
  null
  
)

export default component.exports